import { render } from "./InnovationSection.vue?vue&type=template&id=3fbe121e&scoped=true"
import script from "./InnovationSection.vue?vue&type=script&lang=js"
export * from "./InnovationSection.vue?vue&type=script&lang=js"

import "./InnovationSection.vue?vue&type=style&index=0&id=3fbe121e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbe121e"]])

export default __exports__